/*
 * Copyright (c) 2022. Nedaware SL
 */

import {ApiService} from '../api.service';
import {Token} from './token';
import {LoginAnswerInterface, LoginInterface, LoginRequestInterface} from '../login-interface';
import {map} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import * as moment from 'moment';
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private _token: Token;
    private _timeoutId = null;
    private _mercureToken: string;

    public sessionChanges = new Subject<void>();

    constructor(private _urlService: ApiService) {

        this._token = Token.fromLocalStorage();
        this._setUpTokenTimeout();

    }

    public checkLogin() {
        return this._token.isValid() && !this._token.isBaja();
    }

    public login(login: LoginRequestInterface): Promise<Token> {
        return this._urlService
            .post<LoginAnswerInterface>(LoginInterface.LOGIN_ENDPOINT, login)
            .pipe(map(answer => {
                this._token = Token.fromLoginAnswer(answer.body);
                this._token.store();
                this._mercureToken = answer.body['mercureToken'];
                localStorage.setItem('mercureToken', this._mercureToken);
                this._setUpTokenTimeout();
                this.sessionChanges.next();
                return this._token;
            }, error => {
                console.log(error)
            })).toPromise();
    }

    public logout() {

        this._token = Token.removeFromStorage();
        clearTimeout(this._timeoutId);
        this.sessionChanges.next();
    }

    public useToken(token: string) {
        this._token = Token.fromStr(token);
        this._token.store();
        this._setUpTokenTimeout();
        this.sessionChanges.next();
    }

    get token(): Token {
        return this._token;
    }

    get mercureToken(): string {
        return localStorage.getItem('mercureToken');
    }

    private _setUpTokenTimeout() {
        if (this._timeoutId !== null) {
            clearTimeout(this._timeoutId);
        }
        if (this._token.isValid()) {
            const intervalMs = -1 * moment().diff(this._token.expiration, 'ms');
            this._timeoutId = setTimeout(() => this.sessionChanges.next(), intervalMs);
        }
    }
}
